import { render, staticRenderFns } from "./aiButton.vue?vue&type=template&id=5d02f140&scoped=true&"
import script from "./aiButton.vue?vue&type=script&lang=js&"
export * from "./aiButton.vue?vue&type=script&lang=js&"
import style0 from "./aiButton.vue?vue&type=style&index=0&id=5d02f140&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d02f140",
  null
  
)

export default component.exports